/*
 *
 * @Copyright 2021 VOID SOFTWARE, S.A.
 *
 */

export const VERSION = process.env.REACT_APP_COMMIT;
export const API_URL = process.env.REACT_APP_API_URL;
